
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { useAuth } from '@/context/AuthContext';
import { DashboardHeader, DashboardTabs } from '@/components/dashboard';
import ModernDashboard from '@/components/dashboard/ModernDashboard';

const Dashboard = () => {
  const { profile } = useAuth();
  
  const isEntreprise = profile?.role === 'entreprise';
  const isCandidat = profile?.role === 'candidat';
  const isAdmin = profile?.role === 'admin';

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow bg-gray-50 py-6 md:py-12">
        <div className="container mx-auto px-3 md:px-4">
          <DashboardHeader 
            isCandidat={isCandidat} 
            isEntreprise={isEntreprise} 
            isAdmin={isAdmin} 
          />
          
          <div className="my-8">
            {isAdmin ? (
              <DashboardTabs 
                isCandidat={isCandidat} 
                isEntreprise={isEntreprise} 
                isAdmin={isAdmin} 
              />
            ) : (
              <ModernDashboard />
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Dashboard;
